import React, { useState, useEffect, useRef } from "react";
import {
  X,
  CheckCircle,
  Calendar,
  Home,
  Milestone,
  AlertTriangle,
  Clock,
  Wallet,
  DollarSign,
  Search,
  ChevronDown,
  ChevronUp,
  HandCoins,
  BookLock,
} from "lucide-react";
import DatePicker from "react-datepicker";
import { Button } from "@mui/material";
import { Modal } from "react-bootstrap";
import {
  formatDateStringdot,
  formatTimeFormat,
  handleError,
} from "../../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  get_discount_ledger_data,
} from "../../ServiceConnection/serviceconnection";
import DummyDriver from "../../assets/dummyDriver.jpeg";
import Loader from "../Loader";

const DriverDayWise = ({ activeSection, driverData, imageLink }) => {
  const [customDateRange, setCustomDateRange] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [dateRange, setDateRange] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [show, setShow] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const [driverDatasingle, setDriverDataSingle] = useState();
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [ledgerDataFilter, setLedgerDataFilter] = useState([]);
  const [dicsount_charge, setdiscount_charge] = useState("Discount");
  // const [imageLink, setImageLink] = useState("");
  // Pagination state

  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const driverDropdownRef = useRef(null);

  // Fix: Only search by name and ID (which exists in the driver objects)
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name : "").includes(driverSearchQuery) ||
          (driver.primary_id ? driver.primary_id.toString() : "").includes(
            driverSearchQuery
          )
      )
    : [];

  const handleDateRangeChange = (e) => {
    let value = e.target.value;
    console.log(value);
    setDateRange(value);
    setCustomDateRange(value === "custom");
  };

  const master_data_get = async (start_date, end_date, flag, select_type) => {
    // if (selectedDriver === null) return;
    //console.log("select_type", select_type);
    //console.log("flag", flag);
    const current_date = new Date(); // Always available

    if (flag == 2) {
      if (select_type == 7) {
        // Last 7 days
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(current_date.getDate() - 7);

        start_date = formatDate(sevenDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == 30) {
        // Last 30 days
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(current_date.getDate() - 30);

        start_date = formatDate(thirtyDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == 90) {
        // Last 90 days
        const ninetyDaysAgo = new Date();
        ninetyDaysAgo.setDate(current_date.getDate() - 90);

        start_date = formatDate(ninetyDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == "custom") {
        // Custom date range
        start_date = formatDate(new Date(startDate));
        end_date = formatDate(new Date(endDate));
      }
    }

    // Format date function (YYYY-MM-DD)
    function formatDate(dateObj) {
      console.log(dateObj);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObj.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("dicsount_charge", dicsount_charge);
    if (selectedDriver === null) {
      fd.append("booking_id", 0);
      fd.append("user_id", 0);
    } else {
      if (selectedDriver?.booking_data?.primary_id) {
        fd.append("booking_id", selectedDriver.booking_data.primary_id);
      } else {
        fd.append("booking_id", "0");
      }
      fd.append("user_id", selectedDriver?.primary_id);
    }
    await server_post_data(get_discount_ledger_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setLedgerData(Response.data.message.discount_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const loadLedger = () => {
    //console.log("dateRange", dateRange);
    if (dateRange != "All" && dateRange != "") {
      //console.log("2");
      master_data_get(startDate, endDate, 2, dateRange);
    } else {
      //console.log("1");
      master_data_get("", "", 1, "");
    }
  };

  const filteredTransactions =
    ledgerData && ledgerData.length > 0 && ledgerData;
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTransactions
    ? filteredTransactions.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredTransactions
    ? Math.ceil(filteredTransactions.length / itemsPerPage)
    : 0;
  // console.log(selectedDriver.name)
  const handleExportCSV = (data, filename = "export.csv") => {
    const drivername = selectedDriver.name;

    const fieldMap = {
      date: "Created Date",
      drivername: "Driver Name",
      total_rent: "Total Rent",
      due_rent: "Due Rent",
      paid_rent: "Paid Rent",

      total_surcharges: "Total Surcharges",
      paid_surcharges: "Paid Surcharges",
      due_surcharges: "Due Surcharges",

      total_tolls: "Total Tolls",
      paid_tolls: "Paid Tolls",
      due_tolls: "Due Tolls",

      total_damagefees: "Total Damage Fees",
      paid_damage: "Paid Damage",
      due_damage: "Due Damage",

      total_tickets: "Total Tickets",
      paid_ticket: "Paid Ticket",
      due_ticket: "Due Ticket",

      total_other_charges: "Total Other Charges",
      paid_other_charges: "Paid Other Charges",
      due_other_charges: "Due Other Charges",

      // total_latefees: "Total Late Fees",
      // paid_latefees: "Paid Late Fees",
      // due_latefees: "Due Late Fees",

      total_ipass: "Total IPass",
      total_maintance: "Total Maintenance",

      total_discount: "Total Discount",
      total_amount: "Total Amount",
      total_advance: "Total Advance",
      total_paid: "Total Paid",
      total_due: "Total Due",
    };

    const fields = Object.keys(fieldMap);
    const headers = Object.values(fieldMap);
    const csvRows = [];

    // Add custom headers
    csvRows.push(headers.join(","));

    // Add data rows
    for (const row of data) {
      const values = fields.map((field) => {
        let value = "";

        if (field === "drivername") {
          value = drivername;
        } else if (field === "date") {
          value = formatDateStringdot(row.entry_date); // Adjust based on your date structure
        } else {
          value = row[field] != null ? row[field] : "";
        }

        const escaped = ("" + value).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });

      csvRows.push(values.join(","));
    }

    // Create Blob and trigger download
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Generate page buttons
  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [driverDropdownRef]);

  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    master_data_get("", "", 1, "");
    setDriverDataSingle(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
  };

  const handleViewClick = (transaction) => {
    setSelectedTransaction(transaction);
    setShowModal(true);
  };

  const handleChargeChange = (e) => {
    setdiscount_charge(e.target.value);
    setLedgerData([]);
  };
  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="driver-day-wise"
        className={`accounting-section ${
          activeSection === "driver-day-wise" ? "" : "accounting-hidden"
        }`}
      >
        <div className="accounting-section-header">
          <h2 className="accounting-section-title">
            {dicsount_charge == "Discount" ? "Discount" : "Services Charges"}{" "}
            Ledger
          </h2>
          <div className="accounting-header-actions">
            <button
              className="accounting-btn accounting-btn-primary"
              type="button"
              onClick={() =>
                handleExportCSV(filteredTransactions, "transactions.csv")
              }
            >
              Export CSV
            </button>
          </div>
        </div>

        <div className="accounting-ledger-container">
          <div className="accounting-ledger-main">
            <div className="accounting-ledger-filters">
              <div className="accounting-filter-row">
                <div className="accounting-filter-group">
                  <label htmlFor="driver-select" className="accounting-label">
                    Select Driver
                  </label>
                  <div className="position-relative" ref={driverDropdownRef}>
                    <div
                      className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() =>
                        setIsDriverDropdownOpen(!isDriverDropdownOpen)
                      }
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        // paddingTop: "10px",
                        marginTop: "6px",
                      }}
                    >
                      {selectedDriver ? (
                        <div className="fw-medium">
                          {selectedDriver.name}{" "}
                          {selectedDriver.plan
                            ? `${selectedDriver.plan} - `
                            : ""}
                          {selectedDriver.driverId}
                        </div>
                      ) : (
                        <div className="">Choose a driver</div>
                      )}
                      <div
                        className="position-absolute"
                        style={{
                          bottom: "6px",
                          right: "10px",
                          pointerEvents: "none",
                        }}
                      >
                        {isDriverDropdownOpen ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </div>
                    </div>

                    {isDriverDropdownOpen && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                        style={{ zIndex: 1000 }}
                      >
                        <div className="p-2 border-bottom">
                          <div className="input-group">
                            <span
                              className="input-group-text bg-white border-end-0"
                              style={{ marginTop: "5px" }}
                            >
                              <Search size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control border-start-0"
                              placeholder="Search by name or ID..."
                              value={driverSearchQuery}
                              onChange={(e) =>
                                setDriverSearchQuery(e.target.value)
                              }
                              autoFocus
                            />
                          </div>
                        </div>
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                          {filteredDrivers.length > 0 ? (
                            filteredDrivers.map((driver) => (
                              <div
                                key={driver.primary_id}
                                className="p-2 border-bottom hover-bg-light cursor-pointer"
                                onClick={() => handleSelectDriver(driver)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="fw-medium">{driver.name}</div>
                                <div className="small text-muted">
                                  ID: {driver.primary_id}
                                  {/* - Outstanding:{" "}
                              {driver.outstanding} */}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-3 text-center text-muted">
                              No drivers found
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="accounting-filter-group">
                  <label
                    htmlFor="date-range-select"
                    className="accounting-label"
                  >
                    Select Type
                  </label>
                  <div className="accounting-date-range-group">
                    <select
                      id="date-range-select"
                      className="accounting-select"
                      value={dicsount_charge}
                      onChange={(e) => handleChargeChange(e)}
                    >
                      <option value="Discount">Discount</option>
                      <option value="Charges">Charges</option>
                    </select>
                  </div>
                </div>
                <div className="accounting-filter-group">
                  <label
                    htmlFor="date-range-select"
                    className="accounting-label"
                  >
                    Date Range
                  </label>
                  <div className="accounting-date-range-group">
                    <select
                      id="date-range-select"
                      className="accounting-select"
                      value={dateRange}
                      onChange={handleDateRangeChange}
                    >
                      <option value="All">All Transactions</option>
                      <option value="7">Last 7 Days</option>
                      <option value="30">Last 30 Days</option>
                      <option value="90">Last 90 Days</option>
                      <option value="custom">Custom Range</option>
                    </select>
                    <button
                      id="load-ledger-btn"
                      className="accounting-btn accounting-btn-primary"
                      type="button"
                      onClick={loadLedger}
                    >
                      Load Ledger
                    </button>
                  </div>
                </div>
              </div>

              {dateRange === "custom" && (
                <div className="accounting-custom-date-range">
                  <div className="accounting-filter-group">
                    <label htmlFor="start-date" className="accounting-label">
                      From Date
                    </label>
                    <div className="accounting-date-input-wrapper">
                      <DatePicker
                        id="start-date"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        className="accounting-date-input"
                        placeholderText="MM/DD/YYYY"
                        dateFormat="MM/dd/yyyy"
                      />
                      <Calendar className="accounting-date-icon" size={18} />
                    </div>
                  </div>
                  <div className="accounting-filter-group">
                    <label htmlFor="end-date" className="accounting-label">
                      To Date
                    </label>
                    <div className="accounting-date-input-wrapper">
                      <DatePicker
                        id="end-date"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="accounting-date-input"
                        placeholderText="MM/DD/YYYY"
                        dateFormat="MM/dd/yyyy"
                      />
                      <Calendar className="accounting-date-icon" size={18} />
                    </div>
                  </div>
                </div>
              )}

              {selectedDriver != null && (
                <div className="accounting-driver-profile">
                  <div className="accounting-driver-avatar-container">
                    <img
                      // src={
                      //   selectedDriver.user_image &&
                      //   selectedDriver.user_image.trim() !== "" &&
                      //   selectedDriver.user_image.trim() !== "null"
                      //     ? imageLink + selectedDriver.user_image
                      //     : DummyDriver
                      // }
                      src={DummyDriver}
                      alt="Driver Photo"
                      className="accounting-driver-avatar-large"
                      // onError={DummyDriver}
                    />
                  </div>
                  <div>
                    <h3 className="accounting-driver-name-large">
                      {selectedDriver.name}
                    </h3>
                    <p className="accounting-driver-details m-0">
                      Booking Id: #B{selectedDriver?.booking_data?.primary_id}
                    </p>
                    {/* <p className="accounting-driver-details m-0">
                                        Outstanding:{" "}
                                        {Number(selectedDriver?.total_balance || 0) -
                                            (Number(selectedDriver?.due_damage || 0) +
                                                Number(selectedDriver?.due_ticket || 0) +
                                                Number(selectedDriver?.due_tolls || 0) +
                                                Number(selectedDriver?.due_rent || 0))}
                                    </p> */}
                  </div>
                </div>
              )}
            </div>

            <div className="accounting-table-container newWithTable">
              <table className="accounting-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>($)toll</th>
                    {dicsount_charge === "Discount" ? (
                      <>
                        <th>($)Rent</th>
                        {/* <th>($)late Fees</th> */}
                      </>
                    ) : (
                      <></>
                    )}
                    <th>($)Ticket</th>
                    <th>($)Damage</th>
                    <th>($)Others</th>
                    <th>($)Total</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems &&
                    currentItems.map((transaction, index) => (
                      <tr key={transaction.primary_id}>
                        {dicsount_charge === "Discount" ? (
                          <>
                            <td>{index + 1}</td>
                            <td>
                              {formatDateStringdot(transaction.discount_date)}
                            </td>
                            <td>{transaction.toll_discount}</td>
                            <td>{transaction.rent_discount}</td>
                            {/* <td>{transaction.latefees_discount}</td> */}
                            <td>{transaction.ticket_discount}</td>
                            <td>{transaction.damage_discount}</td>
                            <td>{transaction.other_charges_discount}</td>
                            <td>{transaction.discount_charge}</td>
                          </>
                        ) : (
                          <>
                            <td>{index + 1}</td>
                            <td>
                              {formatDateStringdot(transaction.service_date)}
                            </td>
                            <td>{transaction.toll_charge}</td>
                            {/* <td>{transaction.rent_discount}</td> */}
                            <td>{transaction.ticket_charge}</td>
                            <td>{transaction.damage_charge}</td>
                            {/* <td>{transaction.latefees_discount}</td> */}
                            <td>{transaction.other_charge}</td>
                            <td>
                              {[
                                transaction.toll_charge,
                                transaction.ticket_charge,
                                transaction.damage_charge,
                                transaction.other_charge,
                              ]
                                .map((val) => parseFloat(val) || 0)
                                .reduce((acc, curr) => acc + curr, 0)
                                .toFixed(2)}
                            </td>
                          </>
                        )}

                        {/* <td>   <button
                        className="accounting-action-btn"
                        onClick={() => handleViewClick(transaction)}
                      >
                        View
                      </button></td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {filteredTransactions && filteredTransactions.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, filteredTransactions.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {filteredTransactions.length}
                    </span>{" "}
                    transactions
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    transactions
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
          className="transaction-details-modal"
        >
          <Modal.Header className="border-0 pb-0">
            <Modal.Title className="w-100 text-left">
              Transaction Details: {selectedTransaction?.primary_id}
            </Modal.Title>
            <Button
              variant="link"
              onClick={() => setShowModal(false)}
              className="close-button p-0 position-absolute"
            >
              <X size={20} color="#5B93FF" />
            </Button>
          </Modal.Header>
          {selectedTransaction && (
            <Modal.Body className="pb-4">
              <div className="status-section d-flex justify-content-between">
                <div className="status-section d-flex mb-0">
                  <div className="status-icon-wrapper">
                    <CheckCircle
                      size={32}
                      color="#3C82F6"
                      className="status-icon"
                    />
                  </div>
                  <div className="status-info">
                    <h4 className="status-title">Payment Completed</h4>
                    <p className="status-date mb-0">
                      {formatDateStringdot(selectedTransaction.entry_date)} -
                      {formatTimeFormat(selectedTransaction.entry_date)}
                    </p>
                  </div>
                </div>
                <p
                  className={
                    selectedTransaction.status === "Credit"
                      ? "payment-ledger-status-paid"
                      : selectedTransaction.status === "Debit"
                      ? "payment-ledger-status-unpaid"
                      : ""
                  }
                  style={{
                    borderRadius: "15px",
                    fontSize: "14px",
                    padding: "5px 10px",
                  }}
                >
                  {selectedTransaction.status}
                </p>
              </div>

              <div className="row g-4">
                <div className="col-md-12">
                  <div className="details-card">
                    <h5 className="details-header mb-3">Transaction Details</h5>
                    <div className="details-list">
                      <div className="details-item">
                        <span className="detail-label">Transaction ID:</span>
                        <span className="detail-value">
                          {selectedTransaction.transaction_id}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="detail-label">Amount:</span>
                        <span className="detail-value">
                          ${selectedTransaction.total_amount.toFixed(2)}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="detail-label">Payment Method:</span>
                        <span className="detail-value">
                          {selectedTransaction.payment_mode}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="detail-label">Payment For:</span>
                        <span className="detail-value">
                          {selectedTransaction.transaction_note}
                        </span>
                      </div>
                      {/* <div className="details-item">
                          <span className="detail-label">Stripe ID:</span>
                          <span className="detail-value">
                            {selectedTransaction.transaction_id}
                          </span>
                        </div> */}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6">
                    <div className="details-card">
                      <h5 className="details-header mb-3">Driver Information</h5>
                      <div className="details-list">
                        <div className="details-item align-items-center mb-3">
                          <div className="d-flex align-items-center">
                            <div className="driver-avatar me-3">
                              <img
                                src={
                                  selectedTransaction.user_data?.[0]?.user_image &&
                                  selectedTransaction.user_data[0].user_image.trim() !==
                                    "" &&
                                  selectedTransaction.user_data[0].user_image
                                    .trim()
                                    .toLowerCase() !== "null"
                                    ? imageLink +
                                      selectedTransaction.user_data[0].user_image
                                    : "https://avatar.iran.liara.run/public/36"
                                }
                                alt="Driver"
                                className="rounded-circle"
                                style={{ width: "40px", height: "40px" }}
                              />
                            </div>
                            <div>
                              <div className="fw-medium">
                                {selectedTransaction.user_data?.[0]?.name}
                              </div>
                              <div className="text-muted small">
                                DR-{selectedTransaction.user_data?.[0]?.primary_id}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="details-item">
                          <span className="detail-label">Payment Plan:</span>
                          <span className="detail-value">
                            {selectedTransaction.booking_data &&
                              (() => {
                                const typeMap = {
                                  1: "Daily",
                                  2: "Weekly",
                                };
                                const period =
                                  typeMap[
                                    selectedTransaction.booking_data[
                                      "payment_day_week"
                                    ]
                                  ] || "Unknown";
                                return `${period} ($${
                                  selectedTransaction.booking_data[
                                    "per_date_charge"
                                  ]
                                }/${period.toLowerCase()})`;
                              })()}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="detail-label">Email:</span>
                          <span className="detail-value">
                            {selectedTransaction.user_data?.[0]?.email}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="detail-label">Phone:</span>
                          <span className="detail-value">
                            {selectedTransaction.user_data?.[0]?.mobile_no}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                {/* {console.log(selectedTransaction)} */}
                {/* Payment Categories Section */}
                <div className="col-12 mt-4">
                  <div className="details-card payment-categories">
                    <h5 className="details-header mb-3">Payment Categories</h5>
                    <div className="row g-3 mt-2">
                      {/* Payment Category Items */}
                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <Home size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Rent</div>
                              <div className="category-amount">
                                ${selectedTransaction?.rent || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <BookLock size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Deposit</div>
                              <div className="category-amount">
                                ${selectedTransaction?.deposit || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <HandCoins size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Advance</div>
                              <div className="category-amount">
                                ${selectedTransaction?.total_advance}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <Milestone size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Tolls</div>
                              <div className="category-amount">
                                ${selectedTransaction?.tolls || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <AlertTriangle size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Damage</div>
                              <div className="category-amount">
                                ${selectedTransaction?.damagefees || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-3">
                          <div className="payment-category-item">
                            <div className="d-flex align-items-center">
                              <div className="category-icon-wrapper me-3">
                                <AlertTriangle size={18} color="#3C82F6" />
                              </div>
                              <div>
                                <div className="category-label">Surcharges</div>
                                <div className="category-amount">
                                  $
                                  {selectedTransaction?.surcharges ||
                                    "0.00"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}

                      {/* <div className="col-md-3">
                      <div className="payment-category-item">
                        <div className="d-flex align-items-center">
                          <div className="category-icon-wrapper me-3">
                            <Clock size={18} color="#3C82F6" />
                          </div>
                          <div>
                            <div className="category-label">Late Fees</div>
                            <div className="category-amount">
                              ${selectedTransaction?.latefees || "0.00"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <Wallet size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">Ticket</div>
                              <div className="category-amount">
                                ${selectedTransaction.tickets || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {console.log(selectedTransaction, "selectedTransaction")}
                      <div className="col-md-3">
                        <div className="payment-category-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3">
                              <Wallet size={18} color="#3C82F6" />
                            </div>
                            <div>
                              <div className="category-label">
                                Other Charges
                              </div>
                              <div className="category-amount">
                                ${selectedTransaction.other_charges || "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="payment-category-item total-item">
                          <div className="d-flex align-items-center">
                            <div className="category-icon-wrapper me-3 total-icon">
                              <DollarSign size={18} color="#FFFFFF" />
                            </div>
                            <div>
                              <div className="category-label">Total</div>
                              <div className="category-amount fw-bold">
                                ${selectedTransaction.total_amount.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}
        </Modal>
      </section>
    </>
  );
};

export default DriverDayWise;
